/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Nickname_HintInputs */

const en_us2_clubs_nickname_hint = /** @type {(inputs: Clubs_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's the only name other members see.`)
};

const pt_br2_clubs_nickname_hint = /** @type {(inputs: Clubs_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o único nome que os outros membros veem.`)
};

const es_419_clubs_nickname_hint = /** @type {(inputs: Clubs_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es el único nombre que ven los demás miembros.`)
};

const pt_pt2_clubs_nickname_hint = /** @type {(inputs: Clubs_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o único nome que os outros membros veem.`)
};

const fr_fr2_clubs_nickname_hint = /** @type {(inputs: Clubs_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est le seul nom que voient les autres membres.`)
};

const de_de2_clubs_nickname_hint = /** @type {(inputs: Clubs_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur diesen Namen sehen die anderen Mitglieder.`)
};

const it_it2_clubs_nickname_hint = /** @type {(inputs: Clubs_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È l'unico nome che vedono gli altri membri.`)
};

/**
* | output |
* | --- |
* | "It's the only name other members see." |
*
* @param {Clubs_Nickname_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_nickname_hint = /** @type {((inputs?: Clubs_Nickname_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Nickname_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_nickname_hint(inputs)
	if (locale === "es-419") return es_419_clubs_nickname_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_nickname_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_nickname_hint(inputs)
	if (locale === "de-DE") return de_de2_clubs_nickname_hint(inputs)
	if (locale === "it-IT") return it_it2_clubs_nickname_hint(inputs)
	return en_us2_clubs_nickname_hint(inputs)
});
export { clubs_nickname_hint as "clubs.nickname_hint" }